import StaffIndex from "@/views/staff/StaffIndex.vue";

const staff = [
    {
        path: '/staff',
        name: 'staff',
        component: StaffIndex
    }
]

export default staff;